import type { SxProps, Theme } from "@mui/material/styles";

export const menu: SxProps<Theme> = (theme) => ({
  position: "absolute",
  top: "calc(100% + 8px)",
  insetInlineEnd: 0,
  width: 210,
  bgcolor: "background.paper",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 2,
  boxShadow: theme.shadows[4],
  p: 1,
  zIndex: 31,
  display: "flex",
  flexDirection: "column",
  gap: 0.25,
});

export const menuItem: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: 1.125,
  px: 1.25,
  py: 1.125,
  borderRadius: 1.25,
  border: "none",
  bgcolor: "transparent",
  cursor: "pointer",
  fontFamily: theme.typography.fontFamily,
  color: "text.primary",
  textDecoration: "none",
  width: "100%",
  textAlign: "start",
  "&:hover": {
    bgcolor: theme.palette.action.hover,
  },
});

export const menuItemLabel: SxProps<Theme> = {
  fontSize: "0.8125rem",
  fontWeight: 600,
};

export const menuItemIcon: SxProps<Theme> = (theme) => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.text.secondary,
});

export const logoutItem: SxProps<Theme> = (theme) => ({
  ...menuItem(theme),
  color: "error.main",
  "&:hover": {
    bgcolor: theme.palette.action.hover,
  },
});

export const logoutItemLabel: SxProps<Theme> = {
  fontSize: "0.8125rem",
  fontWeight: 600,
  color: "error.main",
};

export const logoutItemIcon: SxProps<Theme> = (theme) => ({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.error.main,
});
